module.exports = __webpack_public_path__ + "img/arrow-right-green-active.6c8f3f72.svg";